import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { UppFloorPlanStageComponent } from './stage/canvas/upp-floor-plan-stage.component';
import { UppKonvaFloorPlanHostComponent } from './stage/host/upp-konva-floor-plan-host.component';

/**
 * Stage Konva + internal host **`upp-konva-floor-plan`**. Not re-exported from **`UppKonvaModule`**;
 * used as internal bridge for component infrastructure.
 */
@NgModule({
  imports: [CommonModule],
  declarations: [UppFloorPlanStageComponent, UppKonvaFloorPlanHostComponent],
  exports: [UppKonvaFloorPlanHostComponent],
})
export class UppKonvaFloorPlanBridgeModule {}
